import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';

import { AppState } from '../shared/types/app-state.type';
import {
  LoadState,
  RequestReceiptPayload,
  RequestReceiptState,
} from './types/reqest-a-receipt.state.type';

export const requestAReceipt: MemoizedSelector<AppState, RequestReceiptState> =
  createFeatureSelector('requestReceipt');

export const requestReceiptPayload: MemoizedSelector<
  AppState,
  RequestReceiptPayload
> = createSelector(requestAReceipt, state => state.requestPayload);

export const requestReceiptFormIsSubmitted: MemoizedSelector<
  AppState,
  boolean
> = createSelector(
  requestAReceipt,
  state =>
    state.loadState !== LoadState.Idle &&
    state.loadState !== LoadState.Submitting,
);

export const requestReceiptSubmissionSucceeded: MemoizedSelector<
  AppState,
  boolean
> = createSelector(
  requestAReceipt,
  state => state.loadState === LoadState.Success,
);

export const requestReceiptSubmissionFailed: MemoizedSelector<
  AppState,
  boolean
> = createSelector(
  requestAReceipt,
  state => state.loadState === LoadState.Failure,
);
